export enum DataType {
	STR,
	INT,
	DATE,
	BYTEA,
	FLOAT
}
const STR = DataType.STR;
const INT = DataType.INT;
const DATE = DataType.DATE;
const BYTEA = DataType.BYTEA;
const FLOAT = DataType.FLOAT;
export interface Operate {
	Name: string;
	Label: string;
	AllowTypes: DataType[];
}
// åç§æ°æ®ç±»ååè®¸ä½¿ç¨çè¿ç®ç¬¦
export const Operates: Operate[] = [
	{ Name: '=', Label: 'ç­äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '?', Label: 'åå«', AllowTypes: [STR, BYTEA] },
	{ Name: '?>', Label: 'åç¼', AllowTypes: [STR, DATE, BYTEA] },
	{ Name: 'e', Label: 'ä¸ºç©º', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '!=', Label: 'ä¸ç­äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '>', Label: 'å¤§äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '>=', Label: 'å¤§äºç­äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '<', Label: 'å°äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '<=', Label: 'å°äºç­äº', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '!?', Label: 'ä¸åå«', AllowTypes: [STR, BYTEA] },
	{ Name: '!?>', Label: 'éåç¼', AllowTypes: [STR, DATE, BYTEA] },
	{ Name: '<?', Label: 'åç¼', AllowTypes: [STR, DATE, BYTEA] },
	{ Name: '!<?', Label: 'éåç¼', AllowTypes: [STR, DATE, BYTEA] },
	{ Name: 'in', Label: 'å¨åè¡¨', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '!in', Label: 'ä¸å¨åè¡¨', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '~', Label: 'æ­£å', AllowTypes: [STR] },
	{ Name: '!~', Label: 'éæ­£å', AllowTypes: [STR] },
	{ Name: '!e', Label: 'éç©º', AllowTypes: [STR, INT, DATE, BYTEA, FLOAT] },
	{ Name: '_', Label: 'é¿åº¦ç­äº', AllowTypes: [STR, BYTEA] },
	{ Name: '!_', Label: 'é¿åº¦ä¸ç­äº', AllowTypes: [STR, BYTEA] },
	{ Name: '_>', Label: 'é¿åº¦å¤§äº', AllowTypes: [STR, BYTEA] },
	{ Name: '_<', Label: 'é¿åº¦å°äº', AllowTypes: [STR, BYTEA] }
];
